const i18n_fields = {
  EN: [
    { key: 'id', label: 'No.', sortable: false, thStyle: 'width: 5%' },
    { key: 'is_alive', label: 'Usage Status', sortable: true, thStyle: 'width: 10%' },
    { key: 'category', label: 'Category', sortable: true, thStyle: 'width: 12%' },
    { key: 'ext', label: 'Ext', sortable: true, thStyle: 'width: 12%' },
    { key: 'type', label: 'Type', sortable: true, thStyle: 'width: 12%' },
    { key: 'code', label: 'Code', sortable: true },
    // { key: 'func', label: 'More', sortable: false, thStyle: 'width: 10%'  },
  ],
  KO : [
    { key: 'id', label: 'No.', sortable: false, thStyle: 'width: 5%' },
    { key: 'is_alive', label: '사용여부', sortable: true, thStyle: 'width: 10%' },
    { key: 'category', label: '카테고리', sortable: true, thStyle: 'width: 12%' },
    { key: 'ext', label: '종류', sortable: true, thStyle: 'width: 12%' },
    { key: 'type', label: '타입', sortable: true, thStyle: 'width: 12%' },
    { key: 'code', label: '코드', sortable: true },
    // { key: 'func', label: '더 보기', sortable: false, thStyle: 'width: 10%'  },
  ],
  JP: [
    { key: 'id', label: 'No.', sortable: false, thStyle: 'width: 5%' },
    { key: 'is_alive', label: '利用状況', sortable: true, thStyle: 'width: 10%' },
    { key: 'category', label: 'カテゴリー', sortable: true, thStyle: 'width: 12%' },
    { key: 'ext', label: 'Ext', sortable: true, thStyle: 'width: 12%' },
    { key: 'type', label: 'タイプ', sortable: true, thStyle: 'width: 12%' },
    { key: 'code', label: 'コード', sortable: true },
    // { key: 'func', label: 'More', sortable: false, thStyle: 'width: 10%'  },
  ]
}

const fields = { i18n_fields }

export default fields